import React, { Component } from "react";
import * as Survey from "survey-react";
import "survey-react/defaultV2.css";
import "bootstrap/dist/css/bootstrap.css";
import "jquery-ui/themes/base/all.css";
import "jquery-bar-rating/dist/themes/css-stars.css";
import "jquery";
import "surveyjs-widgets";
import ReactGA from "react-ga4";
import "./App.css";
import SASSY from "./SASSY_v1_config.js";
import sassyModel from './model.json';
import seg1 from "./images/Alarmed.jpeg";
import seg2 from "./images/Concerned.jpeg";
import seg3 from "./images/Cautious.jpeg";
import seg4 from "./images/Disengaged.jpeg";
import seg5 from "./images/Doubtful.jpeg";
import seg6 from "./images/Dismissive.jpeg";

let { frontPage, resultPage } = SASSY;
let questions = splitQuestionsIntoPages(SASSY.questions);

ReactGA.initialize("G-GKK3MP6FVQ", { anonymizeIp: false});


class App extends Component {
  json = {
    title: "SASSY",
    requiredText: "",
    startSurveyText: "Take the Quiz!",
    firstPageIsStarted: true,
    pages: [
      frontPage,
      ...questions
    ],
    completedHtml: resultPage
  };

  onValueChanged(result) {
    // console.log("value changed!");
  }

  onComplete(result) {
    this.computeResult(result);
  }

  onCurrentPageChanged(model) {

  }

  computeResult(result) {
    let { Qnum1, Qnum2, Qnum3, Qnum4 } = result.data;

    let resultImages = new Map([
      ["Alarmed", seg1],
      ["Concerned", seg2],
      ["Cautious", seg3],
      ["Disengaged", seg4],
      ["Doubtful", seg5],
      ["Dismissive", seg6]
    ]);

    let responses = new Map(sassyModel.map((response) => {
      let { Qnum1, Qnum2, Qnum3, Qnum4, Segment } = response;
      return [`${Qnum1}${Qnum2}${Qnum3}${Qnum4}`, Segment]
    }));

    let response = responses.get(`${Qnum1}${Qnum2}${Qnum3}${Qnum4}`);

    // window.dataLayer.push({
    //   'event': "SASSY", value: 1,
    //   label: response,
    //   action: "quiz_completion",
    //   category: 'SASSY',
    //   segment: response,
    //   UserSASSYSegment: response
    // });
    ReactGA.event("SASSY", {
      value: 1,
      label: response,
      category: 'general',
      segment: response,
      UserSASSYSegment: response,
      nonInteraction: true
    })
    result.setValue("segment", response)
    result.setValue("resultImage", resultImages.get(response));
  }

  render() {
    Survey.Survey.cssType = "bootstrap";
    var model = new Survey.Model(this.json);
    
    // select first response by default for each question
    // model.getAllQuestions().map( q => q.value =1)
    
    return (
      <div className="App">
        <div className="surveyjs">
          <Survey.Survey
            model={model}
            onComplete={this.onComplete.bind(this)}
            onValueChanged={this.onValueChanged}
            onCurrentPageChanged={this.onCurrentPageChanged}
          />
        </div>
      </div>
    );
  }
}

function splitQuestionsIntoPages(questions) {
  return questions.map(q => ({ elements: [q] }));
}

export default App;
